export const MAILBOX_STORAGE_KEYS = {
  BY_ACCOUNT: "mt6_mailbox_by_account",
} as const;
